import { Button, Grid, Typography } from "@mui/material"
import PaymentAcknowledgementBanner from "../PaymentAcknowledgementBanner"
import failureBanner from "../../../assets/payment_failure_banner.svg"
import { useTranslation } from "react-i18next"

interface PaymentInfoErrorProps {
    onHomeClick?: () => void
}

const PaymentInfoError = (props: PaymentInfoErrorProps) => {
    const { onHomeClick } = props
    const { t } = useTranslation(`acknowledgement`)

    const handleHomeClick = () => {
        onHomeClick != undefined ?? onHomeClick!()
    }

    return (
        <Grid rowSpacing={3} container justifyContent="center" padding={2}>
            <PaymentAcknowledgementBanner bannerUrl={failureBanner} alt="Payment failure banner" />
            <Grid container item justifyContent="center" xs={12}>
                <Typography textAlign="center" variant="h2">{t(`failure.unknown_error`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography textAlign="center">{t(`common:errors.cannot_proceed`)}</Typography>
            </Grid>
            <Grid container item xs={12} justifyContent="center" alignItems="center" columnSpacing={2} rowSpacing={3}>
                <Grid item xs={12} md={3} textAlign="center" hidden={!onHomeClick}>
                    <Button onClick={handleHomeClick} variant="contained" color="primary" size="large">
                        {t(`buttons.home`)}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default PaymentInfoError